import * as index from './generated/index.esm.js';

const Icons = index;

export { Icons };
